import { ReactNode } from "react";
import * as XLSX from "xlsx";

type Column<T> = {
    header: ReactNode;
    accessor: string;
    render?: (value: any, row: T) => ReactNode;
};

const getValue = (obj: any, path: string) =>
    path.split(".").reduce((acc, part) => acc?.[part], obj);

export const convertToExcelData = <T>(data: T[], columns: Column<T>[]) => {
    const headers = columns.map((col) =>
        typeof col.header === "string"
            ? col.header
            : typeof col.header === "number"
                ? col.header.toString()
                : ""
    );

    const rows = data.map((row) =>
        columns.map((col) => {
            const value = getValue(row, col.accessor);
            const rendered =
                col.render?.(value, row) ??
                (typeof value === "string" ? value : JSON.stringify(value));
            return rendered;
        })
    );

    return [headers, ...rows];
};

export const downloadExcel = <T>(data: T[], columns: Column<T>[], filename = "export.xlsx") => {
    const excelData = convertToExcelData(data, columns);
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

    XLSX.writeFile(workbook, filename);
};
